import type { Route } from "@angular/router";

import { UserRouteAccessService } from "../../core";
import { SettingsComponent } from "./settings.component";

export const settingsRoute: Route = {
    path: "settings",
    component: SettingsComponent,
    data: {
        authorities: ["ROLE_USER"],
        breadcrumb: "Settings",
    },
    canActivate: [UserRouteAccessService],
};
